import script from "./vi-rating-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./vi-rating-bar.vue?vue&type=script&lang=ts&setup=true"

import "./vi-rating-bar.vue?vue&type=style&index=0&id=1ef9dc04&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef9dc04"]])

export default __exports__